import { gql } from '@apollo/client';

export const ParagraphActivityPoiNearHotelsFragment = gql`
  fragment ParagraphActivityPoiNearHotels on ParagraphActivityPoiNearHotels {
    id
    title
  }
`;
